/* Header Search */

$(document).ready(function() {

    $(".header-search-button").focus(function(e) {
      if($( ".menu-submenu" ).hasClass( "menu-open" )){
        $('.menu-submenu').removeClass("menu-open");
        $(".menu-arrow-down").attr("aria-expanded", "false");
      }
    });
  
    $(".menu-parent a").focus(function(e){
      $(this).parent().children().children().eq(1).css({"opacity": "1", "z-index": "101"});
    });

    $(".menu-parent a").on('keydown blur', function(e) {
      if (e.shiftKey && e.keyCode === 9) {
        if($(this).parent().children().children().eq(1).css({"opacity": "1", "z-index": "101"})){
          $(this).parent().children().children().eq(1).css({"opacity": "0", "z-index": "-1"});
        }
      }
    });
  
    $(".menu-arrow-down").focus(function(e){
      $(".menu-l2").css({"opacity": "0", "z-index": "-1"});
    });

  });